// extracted by mini-css-extract-plugin
module.exports = {"label":"ForgotPasswordForm_label__1626J","addon":"ForgotPasswordForm_addon__ninFc","btn":"ForgotPasswordForm_btn__2GtJ2","hint":"ForgotPasswordForm_hint__39dt5"};